import { z } from 'zod'

export const rejectRewardTicketSchema = z.object({
  reject_reason: z.string().min(16, { message: 'Mínimo de 16 caracteres' }),
})

export type RejectRewardTicketValidationSchema = z.infer<typeof rejectRewardTicketSchema>
